import { apiClientWithMiddleware } from '../../../utils/API';
export const baseUrl = '/optins/v1/availability';
export const getOptinsStatus = (optinName, portalId) => apiClientWithMiddleware().get(`${baseUrl}/${optinName}`, {
  query: {
    portalId
  }
});
export const updateOptinsStatus = (optinName, status, portalId, currentActionAt) => apiClientWithMiddleware().put(`${baseUrl}/${optinName}/${status}`, {
  query: {
    portalId,
    currentActionAt
  }
});